function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.335 5.083A4.583 4.583 0 0012.75.5 5.3 5.3 0 009 2.225 5.3 5.3 0 005.251.5 4.583 4.583 0 00.668 5.083c0 3.267 3.958 6.875 5.833 8.75l1.9 1.9a.625.625 0 00.442.184h.317a.625.625 0 00.441-.184l1.9-1.9c1.875-1.875 5.834-5.483 5.834-8.75z"
});

var SvgHeartFull = function SvgHeartFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    fill: "#E83C51"
  }, props), _ref);
};

export default SvgHeartFull;